import React, { PropsWithChildren } from 'react'
import { TableSortLabel as MuiTableSortLabel, Box } from '@mui/material'
import { styled } from '@mui/material/styles'

export interface ITableSortLabelProps {
  direction: 'desc' | 'asc' | undefined
  disabled?: boolean
  orderBy: string
  hideSortIcon?: boolean
  orderName: string
  onOrderByChanged: (order: string) => void
}

const CustomTableSortLabel = styled(MuiTableSortLabel)(() => ({
  '&.Mui-active': {
    color: '#292929'
  }
}))

const TableSortLabel = ({
  direction,
  disabled = false,
  orderBy,
  hideSortIcon = false,
  orderName,
  onOrderByChanged,
  children,
  ...props
}: PropsWithChildren<ITableSortLabelProps>) => {
  return (
    <CustomTableSortLabel
      sx={{
        display: 'flex',
        flexGrow: 1,
        width: '100%',
        paddingRight: '12px',
        alignItems: 'center',
        color: orderBy === orderName ? '#292929' : '#656565',
        fontWeight: orderBy === orderName ? 500 : 400
      }}
      active={orderBy === orderName}
      direction={direction as 'asc' | 'desc'}
      onClick={() => onOrderByChanged(orderName)}
      disabled={disabled}
      IconComponent={() => null}
      {...props}>
      {children}
      {!disabled && !hideSortIcon && (
        <Box sx={{ fontWeight: 500, fontSize: '12px' }} ml={1}>
          <i
            className={`fa-regular fa-${
              orderBy !== orderName || direction === 'desc' ? 'arrow-down-wide-short' : 'arrow-up-wide-short'
            }`}
          />
        </Box>
      )}
    </CustomTableSortLabel>
  )
}

export default TableSortLabel
